import { ApiService } from '@app/_services/api.service';
import { BlogVm, BlogShortVm, BlogTopicVm } from './../../_models/blog';
import { Component, ElementRef, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { RowClassArgs, SelectableSettings } from '@progress/kendo-angular-grid';
import { catchError, first, map, shareReplay, take } from 'rxjs/operators';
import { HttpErrorResponse, HttpEventType } from '@angular/common/http';

@Component({
  selector: 'app-blogs',
  templateUrl: './blogs.component.html',
  styleUrls: ['../ohi-university.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class BlogsComponent implements OnInit {
  @ViewChild("fileUpload", { static: false }) fileUpload: ElementRef; 
  files = [];
  maxFileUploadSize = 1 * 1024 * 1024 * 1024; //1 Gb limit
  uploading: boolean = false;

  gridData: BlogShortVm[];
  activeBlog: BlogVm;
  imageList: any[];
  topics: BlogTopicVm[];
  saving: boolean = false;
  selectableSettings: SelectableSettings = {
    enabled: true
  };

  isTopicSelected = (o1: any, o2: any) => o1.id === o2.id;

  constructor(private apiService: ApiService) {}

  gridCallback(context: RowClassArgs) {
    return { isLive: context.dataItem.isLive };
  }

  cellClickHandler({ sender, rowIndex, columnIndex, dataItem, isEdited }) {
    this.apiService
      .getBlog(dataItem.id)
      .subscribe((blog) => (this.activeBlog = blog));
  }

  getHasErrors() {
    return false;
  }

  addBlog() {
    this.activeBlog = new BlogVm();
  }

  editTopic($e, topic: BlogTopicVm) {
    $e.preventDefault();
    $e.stopImmediatePropagation();
    console.log(topic);
  }

  saveBlog() {
    this.saving = true;
    this.apiService.saveBlog(this.activeBlog).subscribe((response) => {
      if (response.code === 200) {
        this.activeBlog = response.blog;
        this.loadBlogs();
      }
      this.saving = false;
    });
  }

  loadBlogs() {
    this.apiService.getBlogsBase().subscribe((data) => {
      this.gridData = data;
    });
  }

  updateTopic(list: any) {
    console.log(list.option.value, list.option.selected);
    if (this.activeBlog && this.activeBlog.id > 0) {
      this.apiService
        .updateRole(
          this.activeBlog.id,
          list.option.value.id,
          list.option.selected
        )
        .subscribe((res) => console.log(res));
    }
  }

  toggleBlogActive(blog) {
    const prevState = blog.isActive;
    this.apiService.turnBlog(blog.id, blog.isActive).subscribe((response) => {
      if (response.code != 200) {
        blog.isActive = prevState;
      }
      console.log(response);
    });
  }
  
  subscription: any;

  uploadFile(file) {
    if (this.subscription) {
      this.subscription.unsubscribe();
      this.subscription = null;
    }
    setTimeout(() => { this.uploading = true }) ;
    const formData = new FormData();
    formData.append('file', file.data, file.data.name);
    file.inProgress = true;
    let uploadObservable = this.apiService.uploadBlogImage(formData).pipe(               
        map(event => {          
          switch (event.type) {
            case HttpEventType.UploadProgress:
              console.log("Progress");
              file.progress = Math.round(event.loaded * 100 / event.total);
              break;
            case HttpEventType.Response:
              console.log("HttpEventType.Response");
              return event;
          }        
      }),
        catchError((error: HttpErrorResponse) => {
          this.uploading = false;
          file.inProgress = false;
          console.log(`An error occured while uploding resoirce: ${error}`);
          return (`${file.data.name} upload failed.`);
        })
      );

      this.subscription  = uploadObservable.subscribe((event: any) => {
        if (typeof event !== 'object') return;
        this.uploading = false;        
        if (event.body.code == 200) {          
          this.activeBlog.thumbnailImage = event.body.uri;
          this.apiService.updateBlogImage(this.activeBlog.id, this.activeBlog.thumbnailImage).subscribe(response => {            
            this.loadBlogImages();
          });
        }          
      });
  }

  updateBlogImage() {
    if (!this.activeBlog || !this.activeBlog.id || !this.activeBlog.thumbnailImage) return;    
    this.apiService.updateBlogImage(this.activeBlog.id, this.activeBlog.thumbnailImage).subscribe(response => {
      console.log(response);
    })    
  }

  private uploadFiles() {
    this.fileUpload.nativeElement.value = '';
    this.files.forEach(file => {
      this.uploadFile(file);
    });
  }


  private loadBlogImages() {
    this.apiService.GetBlogImages().subscribe((data) => {
      this.imageList = data.map((v, i, a) => {
        return { name: v, value: i };
      });
    });
  }

  onClick() {
    const fileUpload = this.fileUpload.nativeElement; 
    fileUpload.onchange = () => {
      if (fileUpload.files[0].size > this.maxFileUploadSize) {
        fileUpload.value = '';
        return;
      }
      this.files.push({ data: fileUpload.files[0], inProgress: false, progress: 0 });
      this.uploadFiles();
    };
    fileUpload.click();
  }

  ngOnInit(): void {
    this.loadBlogs();
    this.loadBlogImages();    
    this.apiService.getBlogTopics().subscribe((data) => {
      this.topics = data;
    });
    this.addBlog();
  }
}
